import { createSlice } from '@reduxjs/toolkit';

const qualificationListSlice = createSlice({
  name: 'qualificationList',
  initialState: {
    listData: [],
  },
  reducers: {
    setList: (state, { payload }) => {
      state.listData = payload;
    },
  },
});

export default qualificationListSlice.reducer;

export const { setList } = qualificationListSlice.actions;
